import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdCard } from "@/components/AdCard";

export const SponsoredAds = ({ plan }) => {
  const [ads, setAds] = useState([]);
  const key = plan.stops.map((s) => s.sid).join(",");
  useEffect(() => {
    api.get(`/plans/${plan.id}/sponsored`).then((r) => setAds(r.data)).catch(() => setAds([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plan.id, key]);
  if (!ads.length) return null;
  return (
    <div className="space-y-2" data-testid="sponsored-ads">
      <p className="text-xs uppercase tracking-wider font-semibold text-stone-500">Nearby deals during your outing</p>
      {ads.map((a, i) => <AdCard key={a.id} ad={a} testId={`sponsored-ad-${i}`} showNow={false} />)}
      <p className="text-[11px] text-stone-400">Sponsored by approved local businesses. Shown only when they're near your route and the deal runs during your plan.</p>
    </div>
  );
};
